import type { CSSProperties, HTMLAttributes } from 'react';
import { kaiTypographyWeb } from '../../../typography';
import { REVIEW_COLORS, REVIEW_RADII, REVIEW_SPACING } from '../reviewFlowTokens';
import type { Tone } from '../reviewFlowTypes';
import {
  resolveStyleOverride,
  type StyleOverride,
} from '../styleOverrides';

const badgeToneStyles: Record<Tone, CSSProperties> = {
  neutral: {
    background: REVIEW_COLORS.surfaceMuted,
    color: REVIEW_COLORS.textMuted,
    borderColor: REVIEW_COLORS.borderStrong,
  },
  success: {
    background: REVIEW_COLORS.successSubtle,
    color: REVIEW_COLORS.success,
    borderColor: REVIEW_COLORS.success,
  },
  info: {
    background: REVIEW_COLORS.infoSubtle,
    color: REVIEW_COLORS.info,
    borderColor: REVIEW_COLORS.info,
  },
  scope: {
    background: REVIEW_COLORS.scopeSubtle,
    color: REVIEW_COLORS.scope,
    borderColor: REVIEW_COLORS.scope,
  },
  warning: {
    background: REVIEW_COLORS.warningSubtle,
    color: REVIEW_COLORS.warning,
    borderColor: REVIEW_COLORS.warning,
  },
  error: {
    background: REVIEW_COLORS.errorSubtle,
    color: REVIEW_COLORS.error,
    borderColor: REVIEW_COLORS.error,
  },
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  label: string;
  tone?: Tone;
  styleOverride?: StyleOverride;
}

export const Badge = ({
  label,
  tone = 'neutral',
  styleOverride: badgeCss,
  style,
  ...props
}: BadgeProps) => {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 20,
        padding: `2px ${REVIEW_SPACING.small}px`,
        borderRadius: REVIEW_RADII.pill,
        border: '1px solid transparent',
        ...kaiTypographyWeb.xxSmallMed,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        ...badgeToneStyles[tone],
        ...style,
        ...resolveStyleOverride(badgeCss),
      }}
      {...props}
    >
      {label}
    </span>
  );
};
